import {type TemplateData, TemplateHandler} from 'easy-template-x';
// import { createResolver } from "easy-template-x-angular-expressions"

const handler = new TemplateHandler({
    /*scopeDataResolver: createResolver({
        angularFilters: {
            toTextLimited: (value: boolean) => value ? 'befristet': 'unbefristet'
        }
    }),*/
    delimiters: {
        tagStart: "${",
        tagEnd: "}",
        containerTagOpen: ">>",
        containerTagClose: "<<"
    },
});

export default async function (url:string, data: TemplateData){
    const response = await fetch(url,{
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    });
    const templateFile = await response.blob();
    return await handler.process(templateFile, data);
}